import { useContext } from 'react';

import Stepper from 'components/stepper';
import { StoreContext } from 'models/import';
import { useTranslation } from 'react-i18next';

function ImportSteps() {
  const { t } = useTranslation();
  const title = `${t('Welcome, USER! You are only few steps away from your tax and data reports.', { ns: 'imports' })}`;
  const steps = [
    `${t('Select your trade platform', { ns: 'imports' })}`,
    `${t('Import your trades into Cointracking', { ns: 'imports' })}`,
    `${t('Ready!', { ns: 'imports' })}`,
  ];

  const { step } = useContext(StoreContext);

  return <Stepper title={title} steps={steps} step={step} />;
}

export default ImportSteps;
